let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2eEVY")).then(() => parcelRequire('12dl7'));